import { Navbar } from "../components/Navbar";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Leaks } from "../components/Leaks";
import { GrowthSystem } from "../components/GrowthSystem";
import { BeforeAfter } from "../components/BeforeAfter";
import { HowItWorks } from "../components/HowItWorks";
import { Industries } from "../components/Industries";
import { PracticalAI } from "../components/PracticalAI";
import { Results } from "../components/Results";
import { ScanForm } from "../components/ScanForm";
import { StrategyCall } from "../components/StrategyCall";
import { About } from "../components/About";
import { FAQ } from "../components/FAQ";
import { FinalCTA } from "../components/FinalCTA";
import { Footer } from "../components/Footer";
import { SEO } from "../components/SEO";

export default function HomePage() {
    return (
        <>
            <SEO
                title="033 Digital — Get Found. Get Booked. Get Growing. | AI-Powered Growth Systems for Local Businesses"
                description="033 Digital builds AI-powered growth systems for local businesses: Google discovery, conversion-focused websites, WhatsApp follow-up, reviews and customer reconnection — working as one connected system. Based in Jadavpur, Kolkata."
                path="/"
            />
            <Navbar />
            <main>
                <Hero />
                <Marquee />
                <Leaks />
                <GrowthSystem />
                <BeforeAfter />
                <HowItWorks />
                <Industries />
                <PracticalAI />
                <Results />
                <ScanForm />
                <StrategyCall />
                <About />
                <FAQ />
                <FinalCTA />
            </main>
            <Footer />
        </>
    );
}
